module.exports = __webpack_public_path__ + "img/UZ.557040c3.png";